import React, {Component} from 'react'
import {observer} from 'mobx-react'
import {checkCurrentPage} from 'router/subscribe'

@observer
export default class Main extends Component {
  componentDidMount() {
    checkCurrentPage()
  }
  render() {
    return (
      <div class="main">
      </div>
    )
  }
}
